module.exports = __webpack_public_path__ + "9f596a63b54b9d0aa35bfd43bf60dde0.png";